<template>
  <div class="background" v-show="show" :class="{transparent: icon === '&#xe7a3;'}">
    <div class="layout">
      <img :src="loading" alt="" style="width: 2rem;height: 2rem;margin-top: .125rem; margin-bottom:  .375rem;" v-show="icon==='loading'"/>
      <em class="iconfont" style="color:white;font-size: 3rem;margin: -.75rem 0 -.375rem 0;" v-html="icon" v-show="icon!=='loading'"></em>
      <div>
        <p style="min-height: 1rem;">{{message1}}</p>
        <p>{{message2}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import loading from '../../assets/images/loading.gif'
export default {
  name: 'toastMessage',
  data () {
    return {
      icon: '&#xe7a3;',
      message1: '',
      message2: '',
      show: false,
      loading: loading
    }
  }
}
</script>

<style scoped>
  /*@font-face {*/
  /*  font-family: 'iconfont';*/
  /*  src: url('../../../public/fonts/iconfont.eot');*/
  /*  src: url('../../../public/fonts/iconfont.eot?#iefix') format('embedded-opentype'),*/
  /*  url('../../../public/fonts/iconfont.woff2') format('woff2'),*/
  /*  url('../../../public/fonts/iconfont.woff') format('woff'),*/
  /*  url('../../../public/fonts/iconfont.ttf') format('truetype'),*/
  /*  url('../../../public/fonts/iconfont.svg#iconfont') format('svg');*/
  /*}*/

  /*.iconfont {*/
  /*  font-family: 'iconfont' !important;*/
  /*  font-size: .426666rem;*/
  /*  font-style: normal;*/
  /*  -webkit-font-smoothing: antialiased;*/
  /*  -moz-osx-font-smoothing: grayscale;*/
  /*}*/
  .background {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10003;
    background: rgba(0,0,0,.5);
  }
  .layout {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    background: rgba(0,0,0,.8);
    border-radius: .625rem;
    /*animation: opa 4s ease;*/
    /*-webkit-animation: opa 4s ease;*/
    padding: 0.7rem 1.25rem;
    z-index: 201;
  }
  p {
    color: #fff;
    text-align: center;
    /*padding: .133333rem;*/
    /* margin: .625rem .625rem 0 .625rem;*/
    margin: 0;
    font-size: 1rem;
  }
  @keyframes opa {
    0% {opacity: 0;}
    10% {opacity: 0.8;}
    90% {opacity: 0.8;}
    100% {opacity: 0;}
  }
  .transparent {
    background: transparent;
  }
</style>
